module.exports = __webpack_public_path__ + "img/route53.67031afb.svg";